import { LOCALES } from 'i18n/locales';

export const redactedAssetPanelIntl = {
    [LOCALES.ENGLISH]: {
        'redactedAssetPanel.assetOwnerLoading': 'Asset owner loading...',
        'redactedAssetPanel.assetOwnerError': 'Error: Asset owner could not be loaded',
        'redactedAssetPanel.heading': 'Hidden asset',
        'redactedAssetPanel.ownerInformation': 'Asset owner information'
    },
    [LOCALES.WELSH]: {
        'redactedAssetPanel.assetOwnerLoading': '[Asset owner loading...]',
        'redactedAssetPanel.assetOwnerError': '[Error: Asset owner could not be loaded]',
        'redactedAssetPanel.heading': '[Hidden asset]',
        'redactedAssetPanel.ownerInformation': 'Gwybodaeth perchennog ased'
    }
};
